import { Link } from '@tanstack/react-router';
import { kr } from '../../lib/money';
import type { RouterOutputs } from '../../lib/trpc';
import { Panel } from '../common/Panel';

type IncomeSource = RouterOutputs['income']['list'][number];

/** Where the money comes from, with what each source is expected to pay. */
export function IncomePanel({ sources }: { sources: IncomeSource[] }) {
  return (
    <Panel
      title="Inkomster"
      action={
        <Link
          to="/settings"
          search={{ tab: 'income' }}
          className="font-medium text-primary hover:underline"
        >
          {sources.length > 0 ? 'Ändra' : 'Lägg till'}
        </Link>
      }
    >
      {sources.length === 0 ? (
        <p className="text-sm text-muted-foreground">
          Inga inkomster än. Lägg till lönen så känner Budgie igen den när den kommer in.
        </p>
      ) : (
        <ul>
          {sources.map((source) => (
            <li
              key={source.id}
              className="flex items-center justify-between gap-3 border-b border-border/60 py-2.5 text-sm last:border-0"
            >
              <span className="min-w-0">
                <span className="block truncate">{source.name}</span>
                <span className="block truncate text-xs text-muted-foreground">
                  {source.memberDisplayName}
                  {source.isVariable && ' · varierar'}
                </span>
              </span>
              <span className="shrink-0 tabular-nums">
                {source.isVariable && <span className="text-muted-foreground">ca </span>}
                {kr(source.expectedAmount)}
              </span>
            </li>
          ))}
        </ul>
      )}
    </Panel>
  );
}
